import styled from 'styled-components';

import { H2, H3 } from '~/src/common/components/Typography';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';
import { media } from '~/src/styles-constants';

export const Header = styled(H2)`
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  ${media.M`
    padding: 0;
  `}
`;

export const Label = styled.div`
  padding: 8px 20px;
  border: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};
  border-bottom: 0;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};
  }

  & > * {
    line-height: 20px;
  }
`;

export const Value = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.common.TEXTS};
`;

export const Key = styled(H3)`
  margin-top: 0;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.palette.common.DISABLED};
`;

export const AdditionalInformationContainer = styled.div`
  font-size: 14px;
  padding-bottom: 40px;
  grid-area: ${ProductGridArea.Attributes};
  ${media.M`
    -ms-grid-column: 1;
    grid-column: 1;
  `}
`;
